import { Link } from "react-router-dom";
import { Button } from "@/components/Base/Button";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";

export const SignupHeader = () => {
  return (
    <Link to={"/login"}>
      <Button className="text-base" variant="ghost-primary">
        Login
        <Icon name={IconNames.login} className="ml-2.5" size={24} />
      </Button>
    </Link>
  );
};
